<template>
  <ModalContainer
    :showModal="showModal"
    title="Find Customer"
    @closeModal="closeModal"
  >
    <div id="modal-body" class="p-6">
      <AlertDanger
        v-if="alert_danger"
        :text="alert_text"
        @closeAlertDanger="hideAlertDanger()"
      />
      <InputForm
        v-model="searchQuery"
        placeholder="Search customer name"
        class="p-2 w-full"
        @input="searchCustomer"
      />
      <div class="gap-4 grid grid-cols-5 mt-4">
        <div class="col-span-4">
          <Select
            label="Branch"
            id="transaction-branch"
            option_placeholder="Select Branch"
            select_class="w-full"
            valueKey="id"
            labelKey="name"
            :options="allBranches"
            v-model="customer.branch_id"
          />
        </div>
        <div class="col-span-1">
          <div>&nbsp;</div>
          <Button button_text="Add Customer" @click="showAddCustomerForm" />
        </div>
      </div>
      <div
        class="gap-6 grid grid-cols-6 mt-4 border-2 border-white/50 rounded-lg p-4"
        v-if="addCustomerForm"
      >
        <div class="col-span-3">
          <InputForm
            id="customer-name"
            v-model="customer.name"
            input_class="w-full mb-5"
            label="Full Name"
            label_class="mb-1 block text-start"
            type="text"
            placeholder="e.g. John Doe"
            :is_required="true"
          />
        </div>
        <div class="col-span-3">
          <InputForm
            id="customer-phone"
            v-model="customer.phone_number"
            input_class="w-full mb-5"
            label="Phone Number"
            label_class="mb-1 block text-start"
            type="text"
            placeholder="e.g. 081234567890"
            :is_required="true"
          />
        </div>
        <div class="col-span-3">
          <InputForm
            id="customer-email"
            v-model="customer.email"
            input_class="w-full mb-5"
            label="Email"
            label_class="mb-1 block text-start"
            type="text"
            placeholder="e.g. example@email.com"
            :is_required="true"
          />
        </div>
        <div class="col-span-3">
          <InputForm
            id="customer-birthdate"
            v-model="customer.birthdate"
            input_class="w-full mb-5"
            label="Birthdate"
            label_class="mb-1 block text-start"
            type="date"
            :is_required="true"
          />
        </div>
        <div class="col-span-3">
          <InputForm
            id="customer-address"
            v-model="customer.address"
            input_class="w-full mb-5"
            label="Address"
            label_class="mb-1 block text-start"
            type="text"
          />
        </div>
        <div class="col-span-3">
          <Select
            id="customer-branch"
            label="Branch"
            option_placeholder="Select Branch"
            select_class="w-full"
            valueKey="id"
            labelKey="name"
            :options="allBranches"
            v-model="customer.branch_id"
          />
        </div>
        <div class="col-span-6">
          <Button
            button_class="w-full"
            button_text="Save"
            @click="addNewCustomer"
          />
        </div>
      </div>
      <div class="max-h-[calc(100dvh-300px)] overflow-y-auto mt-4">
        <DinamicTable :header_columns="table_header" th_class="text-left">
          <TableRow v-if="filteredCustomer.length <= 0">
            <td
              colspan="7"
              class="p-3 text-center italic text-white tracking-widest"
            >
              ~ No data available ~
            </td>
          </TableRow>
          <TableRow v-for="(customer, index) in filteredCustomer" :key="index">
            <TableCell>{{
              index + 1 + (pagination.page - 1) * pagination.perPage
            }}</TableCell>
            <TableCell>{{ customer?.name }}</TableCell>
            <TableCell>{{ getBranchName(customer?.branch_id) }}</TableCell>
            <TableCell
              ><p>
                {{ customer?.phone_number ? customer?.phone_number : "-" }}
              </p>
              <p class="table-cell md:hidden">
                >{{ customer?.email ? customer?.email : "-" }}
              </p></TableCell
            >
            <TableCell class="hidden md:table-cell"
              ><p>{{ customer?.email ? customer?.email : "-" }}</p>
              <p class="table-cell md:hidden">
                {{ customer?.address ? customer?.address : "-" }}
              </p></TableCell
            >
            <TableCell class="hidden md:table-cell">{{
              customer?.address ? customer?.address : "-"
            }}</TableCell>
            <TableCell>
              <Button button_text="Select" @click="selectCustomer(customer)" />
            </TableCell>
          </TableRow>
        </DinamicTable>
      </div>
      <Pagination
        :totalItems="pagination.totalItems"
        :perPage="parseInt(pagination.perPage)"
        :currentPage="parseInt(pagination.page)"
        :previousPageLink="pagination?.previousPageLink"
        :nextPageLink="pagination?.nextPageLink"
        @page-changed="fetchCustomers"
      />
    </div>
  </ModalContainer>
</template>
<script>
import Button from "../buttons/Button.vue";
import SubmitButton from "../form/SubmitButton.vue";
import InputForm from "@/components/form/InputForm.vue";
import AlertDanger from "@/components/alerts/AlertDanger.vue";
import ModalContainer from "@/components/modals/ModalContainer.vue";
import { mapGetters, mapActions } from "vuex";
import DinamicTable from "@/components/organisms/DinamicTable.vue";
import Pagination from "@/components/organisms/Pagination.vue";
import TableRow from "@/components/atoms/table/TableRow.vue";
import TableCell from "@/components/atoms/table/TableCell.vue";
import Select from "@/components/form/Select.vue";
import { validationPhoneNumber, validationEmail } from "@/helpers/validation";

export default {
  name: "ModalFindCustomer",
  emits: ["closeModal", "customer-selected"],
  components: {
    InputForm,
    Button,
    SubmitButton,
    AlertDanger,
    ModalContainer,
    DinamicTable,
    Pagination,
    TableRow,
    TableCell,
    Select,
  },
  computed: {
    ...mapGetters("customers", ["allCustomers", "pagination"]),
    ...mapGetters("branches", ["allBranches"]),

    filteredCustomer() {
      // return this.allCustomers.filter((customer) => {
      //   const matchesBranch =
      //     !this.selectedBranch || customer.branch_id === this.selectedBranch;
      //   return matchesBranch;
      // });

      return this.allCustomers;
    },
  },
  watch: {
    "customer.branch_id": {
      handler(newBranch) {
        console.log("newBranch", newBranch);
        this.fetchCustomers(1, 10, newBranch);
      },
    },
  },
  data() {
    return {
      table_header: ["No", "Name", "Branch", "Phone", "Email", "Address"],
      table_header_small: ["No", "Name", "Branch", "Contact"],
      alert_danger: false,
      alert_text: "",

      showModal: true,
      loadingSubmit: false,
      isEdit: false,

      selectedBranch: null,
      searchQuery: "",
      debounceTimeout: null,

      addCustomerForm: false,

      customer: {
        id: null,
        name: "",
        phone_number: "",
        birthdate: null,
        email: "",
        address: "",
        branch_id: null,
      },
    };
  },
  methods: {
    ...mapActions("customers", [
      "fetchCustomers",
      "deleteCustomerById",
      "createCustomer",
    ]),
    ...mapActions("branches", ["fetchBranches"]),

    capitalizeName(name) {
      return name
        .split(" ")
        .map(
          (word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
        )
        .join(" ");
    },

    async fetchCustomers(page = 1, limit = 10, selectedBranch = null) {
      const params = {
        page,
        limit,
        search: this.searchQuery,
        order: "name",
        sort: "ASC",
        branch_id: this.customer.branch_id,
      };

      await this.$store.dispatch("customers/fetchCustomers", params);
    },

    getBranchName(branchId) {
      const branch = this.allBranches.find((b) => b.id === branchId);
      return branch ? branch.name : "-";
    },

    closeModal() {
      this.showModal = false;
      setTimeout(() => {
        this.$emit("closeModal");
      }, 100);
    },

    showAddCustomerForm() {
      console.log("showAddCustomerForm", this.addCustomerForm);
      this.addCustomerForm = !this.addCustomerForm;
    },

    searchCustomer() {
      clearTimeout(this.debounceTimeout); // Clear any existing timeout
      this.debounceTimeout = setTimeout(() => {
        this.fetchCustomers(1);
      }, 2000); // 2000 milliseconds = 2 seconds
    },
    selectCustomer(customer) {
      this.$emit("customer-selected", { id: customer.id, name: customer.name });
      this.closeModal();
    },
    hideAlertDanger() {
      this.alert_danger = false;
      this.alert_text = "";
    },

    async addNewCustomer() {
      if (!this.customer.name) {
        this.alert_danger = true;
        this.alert_text = "Name cannot be empty!";
        return;
      }
      if (!validationPhoneNumber(this.customer.phone_number)) {
        this.alert_danger = true;
        this.alert_text =
          "The telephone number format consists of 10 - 13 numeric characters!";
        return;
      }
      this.customer.name = this.capitalizeName(this.customer.name);
      // console.log('customer: ', this.customer);
      try {
        const { data } = await this.createCustomer(this.customer);
        console.log("data", data);
        this.$emit("openAlertSuccess_CustomerCreated");

        this.addCustomerForm = false;
        this.customer = {
          id: null,
          name: "",
          phone_number: "",
          birthdate: null,
          email: "",
          address: "",
          branch_id: null,
        };

        this.selectCustomer(data);
      } catch (error) {
        console.error(error);
        this.alert_danger = true;
        this.alert_text = "Error: " + error.message;
      }
    },
  },
  async created() {
    await this.fetchBranches();
    await this.fetchCustomers(1);
  },
};
</script>
